import { Box } from '@mui/material'
import { StatusChip } from './StatusChip'
import { CampaignCostHandlingMethod } from '~/generated/graphql'
import { toBurdenRate } from '~/features/campaign_input/constants/burdenRate'

type Props = {
  isAcceptingEntries: boolean
  hasOfferInProgress: boolean
  isFinished: boolean
  isDenial: boolean
  costHandlingMethod?: CampaignCostHandlingMethod | null
  influencerBurdenRate?: number | null
}

export const StatusChipGroup: React.FC<Props> = ({
  isAcceptingEntries,
  hasOfferInProgress,
  isFinished,
  isDenial,
  costHandlingMethod,
  influencerBurdenRate,
}) => {
  const costHandlingMethodVariant =
    costHandlingMethod === CampaignCostHandlingMethod.ExpenseCampaign
      ? 'expenseCampaign'
      : costHandlingMethod === CampaignCostHandlingMethod.NoChargeCampaign
        ? 'noChargeCampaign'
        : undefined

  if (isFinished) {
    return (
      <Box display="flex" justifyContent="space-evenly" flexWrap="wrap" gap="10px">
        <StatusChip variant="isFinished" />
        {costHandlingMethodVariant && (
          <StatusChip variant={costHandlingMethodVariant} influencerBurdenRate={toBurdenRate(influencerBurdenRate)} />
        )}
      </Box>
    )
  }
  if (isDenial) {
    return (
      <Box display="flex" justifyContent="space-evenly" flexWrap="wrap" gap="10px">
        <StatusChip variant="isDenial" />
        {costHandlingMethodVariant && (
          <StatusChip variant={costHandlingMethodVariant} influencerBurdenRate={toBurdenRate(influencerBurdenRate)} />
        )}
      </Box>
    )
  }

  return (
    <Box display="flex" justifyContent="space-evenly" flexWrap="wrap" gap="10px">
      <StatusChip variant="isAcceptingEntries" active={isAcceptingEntries} />
      <StatusChip variant="hasOfferInProgress" active={hasOfferInProgress} />
      {costHandlingMethodVariant && (
        <StatusChip variant={costHandlingMethodVariant} influencerBurdenRate={toBurdenRate(influencerBurdenRate)} />
      )}
    </Box>
  )
}
